import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    nav: {
      display: 'flex',
      justifyContent: 'space-between',
      backgroundColor: '#0099CC',
      padding: '0px 24px'
    },
    ol: {
      padding: '16px 0px',
      display: 'flex',
      listStyleType: 'none',
      gap: '1rem',
      borderTop: '1px solid #999',
      borderBottom: '1px solid #999',
      margin: 0
    },
    li: {
      display: 'flex',
      alignItems: 'center',
      listStyleType: 'none',
      gap: '1rem',
      margin: 0,
      padding: 0
    },
    liLast: {
      fontWeight: 'bold',
      display: 'flex',
      alignItems: 'center',
      listStyleType: 'none',
      gap: '1rem',
      margin: 0,
      padding: 0
    },
    link: {
      color: 'white',
      cursor: 'pointer'
    },
    linkLast: {
      color: 'white',
      textDecoration: 'none'
    },
    arrowForwardIosIcon: {
      fontSize: 16
    }
  })
);
